// The sliver of CSS selector syntax the map's `select`/`selectAll` calls use:
// a tag name, an `#id`, or those joined by child combinators (`g>rect`).
//
// Matching semantics follow querySelector: the search covers every descendant of
// the node it is called on, and a leading part may match that node itself when it
// is the parent in a child combinator.

const parseCache = new Map();

function parse(selector) {
  const cached = parseCache.get(selector);
  if (cached) return cached;

  const parts = selector.split(">").map((part) => {
    const trimmed = part.trim();
    if (trimmed[0] === "#") return { id: trimmed.slice(1) };
    if (trimmed === "*") return {};
    return { tag: trimmed };
  });

  parseCache.set(selector, parts);
  return parts;
}

function matchesPart(node, part) {
  if (part.tag !== undefined && node.tagName !== part.tag) return false;
  if (part.id !== undefined && node.attrs.id !== part.id) return false;
  return true;
}

function matchesChain(node, parts) {
  let current = node;
  for (let i = parts.length - 1; i >= 0; i--) {
    if (!current || !matchesPart(current, parts[i])) return false;
    current = current.parentNode;
  }
  return true;
}

function walk(node, parts, out, first) {
  const children = node.children;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (matchesChain(child, parts)) {
      out.push(child);
      if (first) return true;
    }
    if (walk(child, parts, out, first)) return true;
  }
  return false;
}

export function queryAll(root, selector) {
  const out = [];
  walk(root, parse(selector), out, false);
  return out;
}

export function queryFirst(root, selector) {
  const out = [];
  walk(root, parse(selector), out, true);
  return out.length ? out[0] : null;
}
